import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import singleRecipientType from 'owa-service/lib/factory/singleRecipientType';
import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
var SHARING_INSTANCE_GUID_PRIOERTYID = 0x8a1c;
export default function setFromInfoToMessage(viewState, message) {
    var from = viewState.from;
    if (from) {
        var isConnectedAccount = false;
        var connectAccountInfos = getUserConfiguration().SessionSettings.ConnectedAccountInfos;
        if (connectAccountInfos) {
            for (var i = 0; i < connectAccountInfos.length; i++) {
                var connectAccountInfo = connectAccountInfos[i];
                if (connectAccountInfo.EmailAddress == from.email.EmailAddress) {
                    isConnectedAccount = true;
                    var extendedProperty = extendedPropertyType({
                        Value: connectAccountInfo.SubscriptionGuid,
                        ExtendedFieldURI: extendedPropertyUri({
                            PropertyId: SHARING_INSTANCE_GUID_PRIOERTYID,
                            DistinguishedPropertySetId: 'Sharing',
                            PropertyType: 'CLSID',
                        }),
                    });
                    if (message.ExtendedProperty) {
                        message.ExtendedProperty.push(extendedProperty);
                    }
                    else {
                        message.ExtendedProperty = [extendedProperty];
                    }
                    message.From = singleRecipientType({
                        Mailbox: {
                            MailboxType: from.email.MailboxType,
                            RoutingType: 'SMTP',
                            EmailAddress: from.email.EmailAddress,
                            Name: connectAccountInfo.DisplayName,
                        },
                    });
                    break;
                }
            }
        }
        if (!isConnectedAccount) {
            message.From = singleRecipientType({
                Mailbox: from.email,
            });
        }
    }
}
//# sourceMappingURL=setFromInfoToMessage.js.map